import React from "react";
import { Link } from "react-router-dom";

import logo from "../assets/images/logo.png";

const About = (props) => {
  return (
    <section
      className={`text-black-600 body-font backgroundColor-white bg-${props.mode}`}
    >
      <div className="container mx-auto flex px-5 py-24 items-center justify-center flex-col">
        <img
          className="lg:w-2/6 md:w-3/6 w-5/6 mb-10 object-cover object-center rounded"
          alt="hero"
          src={logo}
        />

        <div className="text-center lg:w-2/3 w-full">
          <h1
            className={`title-font sm:text-4xl text-3xl mb-4 font-medium text-${
              props.mode === "white" ? "black" : "white"
            }`}
          >
            Prince Paul Dipendu Das Ethical Hacker (Dipendu Das)
          </h1>
          <p className="mb-8 leading-relaxed text-indigo-900">
            Certified Ethical Hacker, Cyber Security Researcher, Computer
            Science Engineer, Founder of Duoples, Web Developer, Cross Platform
            App Developer, Programmer, Blogger, YouTuber, Freelancer,
            Entrepreneur, Digital Marketer, SEO Expert, Graphic Designer, Video
            Editor, Photographer, Video Maker, Musician(Guitarist, Keyboardist),
            Artist, Writer, Poet, Philosopher, Philanthropist, Social Worker,
            Motivational Speaker, Teacher, Trainer, Coach, Mentor, Counselor,
            Consultant, Businessman, Investor, Social Worker, Philosopher,
            Social Worker, Motivational Speaker, Martial Artist
          </p>

          <div className="flex justify-center">
            <Link to="/" className="mr-5">
              <button className="inline-flex text-white bg-indigo-500 border-0 py-2 px-6 focus:outline-none hover:bg-indigo-600 rounded text-lg">
                Home
              </button>
            </Link>
            <Link to="/contact" className="mr-5">
              <button className="ml-4 inline-flex text-gray-700 bg-gray-100 border-0 py-2 px-6 focus:outline-none hover:bg-gray-200 rounded text-lg">
                Contact Me
              </button>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
